export const PRODUCT_CATALOG_SERVICES = {
  EIN: 'ein_creation',
  FORMATION: 'llc_formation',
  BANKING_PREFERRED: 'zb_banking_preferred',
  BANK_OF_AMERICA_OFFER: 'bank_of_america_offer'
};
